import { service } from 'services';
import { basicCRUDAction, hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

export const containerRegistry = {
  registry: {
    getAll: async () => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.GET_ALL,
      apiResult: service.containerRegistry.registry.getAll(),
      isRetrieveItems: true,
    }),

    create: async ({ properties }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.CREATE,
      apiResult: service.containerRegistry.registry.create({ properties }),
      isReFetch: true,
    }),

    get: async ({ id }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.GET,
      apiResult: service.containerRegistry.registry.get({ id }),
    }),

    getV2: async ({ id, appendToEndOfUrl }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.GET_V2,
      apiResult: service.containerRegistry.registry.getV2({ id, appendToEndOfUrl }),
    }),

    checkNameAvailability: async ({ name }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.CHECK_NAME_AVAILABILITY,
      apiResult: service.containerRegistry.registry.checkNameAvailability({ name }),
    }),

    update: async ({ id, properties }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.UPDATE,
      apiResult: service.containerRegistry.registry.update({ id, properties }),
      isReFetch: true,
    }),

    delete: async ({ id }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.DELETE,
      apiResult: service.containerRegistry.registry.delete({ id }),
    }),
  },

  token: {
    getAll: async ({ registryId }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.TOKEN.GET_ALL,
      apiResult: service.containerRegistry.token.getAll({ registryId }),
      isRetrieveItems: true,
    }),

    get: async ({ registryId, tokenId }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.TOKEN.GET,
      apiResult: service.containerRegistry.token.get({ registryId, tokenId }),
    }),

    create: async ({ properties, registryId }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.TOKEN.CREATE,
      apiResult: service.containerRegistry.token.create({ properties, registryId }),
      isAddResponseToStore: true,
    }),

    update: async ({ properties, registryId, tokenId }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.TOKEN.UPDATE,
      apiResult: service.containerRegistry.token.update({ properties, registryId, tokenId }),
    }),

    delete: async ({ registryId, tokenId }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.TOKEN.DELETE,
      apiResult: service.containerRegistry.token.delete({ registryId, tokenId }),
    }),
  },

  repository: {
    getAll: async ({ registryId }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_ALL,
      apiResult: service.containerRegistry.repository.getAll({ registryId }),
      retrieveByFunction: (e) => ({ [registryId]: e }),
    }),

    get: async ({ registryId, repoName }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET,
      apiResult: service.containerRegistry.repository.get({ registryId, repoName }),
      expectedStatusCodes: [404],
      retrieveByFunction: (e) => {
        if (e.httpStatus) {
          return {
            name: repoName,
            tags: [],
          };
        }
        return e;
      },
    }),

    getTags: async ({ registryId, repoName }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS,
      apiResult: service.containerRegistry.repository.getTags({ registryId, repoName }),
      isPassiveLoading: true,
      expectedStatusCodes: [404],
      retrieveByFunction: (e) => {
        if (e.httpStatus) {
          return {
            registryId,
            name: repoName,
            tags: [],
          };
        }
        return { ...e, registryId };
      },
    }),

    getManifest: async ({ registryId, repoName, tagName }) => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_MANIFEST,
      apiResult: service.containerRegistry.repository.getManifest({ registryId, repoName, tagName }),
    }),

    delete: async ({ registryId, repoName }) => basicCRUDAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.DELETE,
      apiResult: service.containerRegistry.repository.delete({ registryId, repoName }),
    }),
  },

  location: {
    getAll: async () => hotGetAction({
      action: ACTIONS_TYPES.CONTAINER_REGISTRY.LOCATION.GET_ALL,
      apiResult: service.containerRegistry.location.getAll(),
      isRetrieveItems: true,
    }),
  },
};
